import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const reportTemplateDetailsAtom = atom({
  key:RecoilAtomKey.reportTemplateDetailsKey,
  default:{}
})

export { reportTemplateDetailsAtom };
